import axios from 'axios';
import React, { useContext } from 'react';
import { ProductContext } from '../../App';

function ExchangeTable(props) {

    const product_context = useContext(ProductContext);
    const { confirmDialogue, setConfirmDialogue, setIsLoading, alert, setAlert } = product_context;

    const orderDetails = props.orderDetails.filter(el => el.status === 'exchanged' || el.status === 'returned');


    const handleReturn = (order) => {
        setConfirmDialogue({
            isOpen: true,
            message: 'Have you received this Product?',
            submitHandle: () => { actualReturn(order) }
        })
    }

    const actualReturn = (order) => {
        setIsLoading(true);
        let data = {
            order: order,
        }
        if (order.status === 'exchanged') {
            data.status = 'exchanged/received'
        }
        else {
            data.status = 'returned/received'
        }
        axios.put(`${process.env.REACT_APP_SERVER_DOMAIN}/sell/${order._id}`, data)
            .then(res => {
                setIsLoading(false);
                setAlert({
                    isOpen: true,
                    message: "Successfull",
                    type: "success",
                })
                props.setChangeSellsState(!props.changeSellsState);
            })
            .catch(err => {
                setAlert({
                    isOpen: true,
                    message: "Something Went Wrong",
                    type: "danger",
                })
                setIsLoading(false);
            })
        setTimeout(() => {
            setAlert({ ...alert, isOpen: false });
        }, 5000);
        setConfirmDialogue({ ...confirmDialogue, isOpen: false });
    }
    return (
        <div>
            <h3 className='text-center my-3'>Return Table:</h3>
            <div className="d-flex align-items-center justify-content-center">
                <div className="stock-table">
                    <table className='table-bordered'>
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Name</th>
                                <th>Instagram ID</th>
                                <th>Item Details</th>
                                <th>Price</th>
                                <th>Address</th>
                                <th>Contact</th>
                                <th>Order Date</th>
                                <th>Delivery Instructions</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {orderDetails?.length !== 0 ? null : <tr><td className='text-danger' colSpan={10}>No Details To Show</td></tr>}
                            {orderDetails?.map((order, i) => {
                                let item_details = order?.product_details?.item_name + ' ' + order?.color + ' ' + order?.size;
                                let date = order?.order_date;
                                let formated_date = date.split('T');
                                return <tr key={i}>
                                    <td>{i + 1}</td>
                                    <td>{order?.customer_details?.name || '-'}</td>
                                    <td>{order?.customer_details?.instagram_id || '-'}</td>
                                    <td>{item_details || '-'}</td>
                                    <td>{order?.price || '-'}</td>
                                    <td>{order?.customer_details?.address || '-'}</td>
                                    <td><a href={`tel:${order?.customer_details?.contact_number}`}>{order?.customer_details?.contact_number || '-'}</a></td>
                                    <td>{formated_date[0]}</td>
                                    <td>{order?.delivery_instructions || '-'}</td>
                                    <td>
                                        <div className='d-flex flex-column'>
                                            <button onClick={() => { handleReturn(order) }} className='btn btn-success'>Got Product</button>
                                        </div>
                                    </td>
                                </tr>
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    )
}

export default ExchangeTable
